/** @format */

import { Component, Input, inject } from '@angular/core';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconMediaPlay
} from '@dsg-tech/homefield-angular-icons';

/** @format */
import { CommonModule } from '@angular/common';

@Component({
	selector: 'product-reviews-play-button',
	templateUrl: './review-play-button.component.html',
	styleUrl: './review-play-button.component.scss',
	imports: [CommonModule, HomefieldIconLibraryModule]
})
export class ReviewPlayButtonComponent {
	homefieldIconsLibraryService = inject(HomefieldIconsLibraryService);
	@Input() isLarge = false;

	iconSize = { small: '24px', large: '40px' };

	constructor() {
		this.homefieldIconsLibraryService.registerIcons([homefieldIconMediaPlay]);
	}
}
